export const handleOpenStartNewJobModal = () => {
    const event = new KeyboardEvent('keydown', {
        key: 'j',
        code: 'KeyJ',
        metaKey: true,
    });
    window.dispatchEvent(event);
};
